package com.fireavert.administration.admin_page.client

import com.fireavert.administration.admin_page.data_models.responses.AdminGetUserCountResponse
import com.fireavert.cache.client.Preferences
import com.fireavert.common.ApiRepository
import com.fireavert.common.Try
import com.fireavert.user.data_models.TokenRefreshService
import kotlinx.coroutines.CoroutineDispatcher
import kotlinx.coroutines.withContext

class AdministrationPageRepositoryImpl(
    private val datasource: AdminPageRepositoryDataSource,
    private val preferences: Preferences,
    ioContext: CoroutineDispatcher,
    tokenRefreshService: TokenRefreshService
) : AdministrationPageRepository, ApiRepository(ioContext, tokenRefreshService) {
    override suspend fun getUserData(): Try<AdminGetUserCountResponse> = withContext(ioContext) {
        callWithRefresh { datasource.getUserData(preferences.token) }
            .map { it }
    }
}